import dynamic from 'next/dynamic';

import { Accordion } from '@natu/ui/Accordion';

import {
  type BlokItem,
  DynamicRender,
  type SBProps,
  type Spacing,
  resolveStoryblokStyles,
  sbEditable,
} from '../../../../utils';
import type { SBAccordionItemProps } from './SBAccordionItem';

const FaqSchemaFromAccordion = dynamic(() =>
  import('./FaqSchemaFromAccordion').then(mod => mod.FaqSchemaFromAccordion),
);

interface SBAccordionProps {
  autogenerateFaqSchema?: boolean;
  sendEvent?: boolean;
  items?: BlokItem[];
  type?: 'multiple' | 'single';
  disabled?: boolean;
  collapsible?: boolean;
  closeAsDefault?: boolean;
  mtMobile?: Spacing;
  mtTablet?: Spacing;
  mtDesktop?: Spacing;
  mbMobile?: Spacing;
  mbTablet?: Spacing;
  mbDesktop?: Spacing;
}

export const SBAccordion = ({ blok }: SBProps<SBAccordionProps>) => {
  const {
    autogenerateFaqSchema,
    sendEvent,
    items,
    type,
    disabled,
    collapsible,
    closeAsDefault,
    mbMobile,
    mbTablet,
    mbDesktop,
    mtMobile,
    mtTablet,
    mtDesktop,
  } = blok;

  if (!Array.isArray(items) || items.length === 0) {
    return null;
  }

  const allItemIds = items.map(item => item._uid);

  const className = resolveStoryblokStyles({
    mt: mtMobile,
    mtTablet,
    mtDesktop,
    mb: mbMobile,
    mbTablet,
    mbDesktop,
  });

  const accordionContent = (
    <DynamicRender data={items} parentProps={{ event: sendEvent ? 'E_FAQ_expand' : undefined }} />
  );

  return (
    <div className={className} {...sbEditable(blok)}>
      {type === 'single' ? (
        <Accordion
          disabled={disabled}
          type="single"
          collapsible={collapsible}
          defaultValue={closeAsDefault ? undefined : allItemIds[0]}
        >
          {accordionContent}
        </Accordion>
      ) : (
        <Accordion
          disabled={disabled}
          type="multiple"
          defaultValue={closeAsDefault ? undefined : allItemIds}
        >
          {accordionContent}
        </Accordion>
      )}
      {autogenerateFaqSchema && <FaqSchemaFromAccordion items={items as SBAccordionItemProps[]} />}
    </div>
  );
};
